module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/main-bg_78734a6427c13e950004b5bc8826a10c.png";